// src/components/ZeroDayMethod/AiReportDisplay.jsx
import React from 'react';
import { motion } from 'framer-motion';

const AiReportDisplay = ({ reportData, onClose }) => {
  if (!reportData) return null;

  const renderValue = (value) => {
    if (typeof value === 'object' && value !== null) {
      if (Array.isArray(value)) {
        return (
          <ul className="list-disc list-inside pl-4">
            {value.map((item, index) => (
              <li key={index} className="text-gray-300 text-sm mb-1">{renderValue(item)}</li>
            ))}
          </ul>
        );
      }
      return (
        <div className="pl-4 border-l border-dark-500 mt-1">
          {Object.entries(value).map(([key, val]) => (
            <div key={key} className="mb-1">
              <strong className="text-accent-cyan capitalize">{key.replace(/([A-Z])/g, ' $1')}: </strong>
              {renderValue(val)}
            </div>
          ))}
        </div>
      );
    }
    return <span className="text-gray-200">{String(value)}</span>;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="fixed inset-0 bg-dark-900/80 backdrop-blur-sm flex items-center justify-center p-4 z-50"
      onClick={onClose} // Close on overlay click
    >
      <div 
        className="bg-dark-700 rounded-2xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto custom-scrollbar border border-accent-purple/30"
        onClick={(e) => e.stopPropagation()} // Prevent close on modal content click
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-accent-purple">
            <i className="fas fa-file-contract mr-2"></i>Zero-Day AI Analysis Report
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
            aria-label="Close report"
          >
            <i className="fas fa-times fa-lg"></i>
          </button>
        </div>

        <div className="space-y-4">
          {Object.entries(reportData).map(([key, value]) => {
            if (key === 'fullLog') return null; // Optionally skip full log in this view
            return (
              <div key={key} className="bg-dark-600 p-4 rounded-lg">
                <h3 className="text-md font-semibold text-accent-cyan capitalize mb-2 border-b border-dark-500 pb-1">
                  {key.replace(/([A-Z])/g, ' $1').trim()}
                </h3>
                {renderValue(value)}
              </div>
            );
          })}
        </div>
         <div className="mt-6 text-center">
            <button
                onClick={onClose}
                className="px-6 py-2 bg-accent-purple hover:bg-accent-purple/80 text-white rounded-lg font-medium transition-colors"
            >
                Close Report
            </button>
        </div>
      </div>
    </motion.div>
  );
};

export default AiReportDisplay;